import { Component, EventEmitter, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { debounceTime } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { SpecialProjectCheck } from 'src/app/shared/services/common/special-project-check';

@Component({
  selector: 'app-search-basic',
  templateUrl: './search-basic.component.html',
  styleUrls: ['./search-basic.component.scss'],
  providers: [ApiService,GlobalConstants]
})


export class SearchBasicComponent implements OnInit {
  private subject: Subject<string> = new Subject();
  searching: boolean = false;
  searchInput: string = '';
  nearBymerchantList: any = [];
  merchantList: any = [];
  selectedCat: any = '';
  pageType: any;

  constructor(
    public _apiService: ApiService,
    private GlobalConstants: GlobalConstants,
    public SpecialProjectCheck: SpecialProjectCheck
  ) { }

  ngOnInit(): void {
    this.checkPageType();
    this.subject.pipe(
      debounceTime(300)
    ).subscribe(searchTextValue => {
      this.populateMerchantList(searchTextValue);
    });
  }
  debouncedPopulateMerchantList(searchTextValue: any) {
    this.subject.next(searchTextValue);
  }


  checkPageType(){
    this.pageType = this.SpecialProjectCheck.checkProject()
  }
  populateMerchantList(event) {
    this.searchInput = event.target.value;
    var params = { name: event.target.value };
    var merchantDiv = document.getElementById('merchant-list');
    if (event.target.value.length > 2) {
      this.searching = true;
      this.merchantList = [];
      this._apiService.getMerchants(params).subscribe(
        (res: any) => {
          this.merchantList = res.data.slice(0, 7);
          setTimeout(() => { this.searching = false; }, 500);
        },
        (err) => {
          this.searching = false;
        }
      );
    }
    else {
      this.merchantList = [];
      this.searching = false;
    }
  }
}
